/* import __COLOCATED_TEMPLATE__ from './coachmark.hbs.js'; */
import Component from '@glimmer/component';
export default class Coachmark extends Component {
  get coachmarkContainerClassNames() {
    const arrowPositionClassNames = this.args.arrowPosition === 'left' ? 'coachmark-arrow-left' : 'coachmark-arrow-right';
    return `coachmark-container ${arrowPositionClassNames} ${this.args.marginTopClassForCoachmarkContainer || 'catalog-shared-mt-300'}`;
  }
}